import produce from 'immer';
import {
  changePassword,
  loginUser,
  logoutUser,
  resetPassword,
  resetPasswordRequest,
  showConfirmPassword,
  showNewPassword,
  showPassword,
  verifySession,
} from './actions';

/* eslint-disable default-case */
/* eslint-disable no-param-reassign */

const initialState = {
  loading: false,
  error: null,
  isLoggedIn: false,
  // Whether the current auth answer is known, as opposed to merely absent. `isLoggedIn`
  // starts false, so on a cold load it cannot tell "signed out" apart from "verifySession
  // hasn't come back yet" — and PrivateRoute now acts on that difference by leaving this
  // origin for the accounts app. Redirecting on the initial false would bounce a user who
  // does have a valid session, and the accounts app would bounce them straight back.
  //
  // Deliberately not persisted (see SetTransform in store/index.js): it describes this
  // page load, so every load waits for a fresh check before handing off.
  sessionChecked: false,
  showPassword: false,
  showNewPassword: false,
  showConfirmPassword: false,
  ability: null,
  tokenExpiresAt: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case loginUser.TRIGGER:
    case logoutUser.TRIGGER:
    case changePassword.TRIGGER:
    case resetPasswordRequest.TRIGGER:
    case resetPassword.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case verifySession.SUCCESS:
    case loginUser.SUCCESS:
      draft.isLoggedIn = true;
      draft.ability = payload.ability;
      draft.tokenExpiresAt = payload.tokenExpiresAt;
      break;
    case logoutUser.SUCCESS:
      draft.isLoggedIn = false;
      draft.ability = null;
      draft.tokenExpiresAt = null;
      // A completed sign-out is an answer too, so don't sit on a loading screen
      // waiting for a verification that already went the other way.
      draft.sessionChecked = true;
      break;
    // FULFILL, so both a successful and a failed verification count as an answer.
    case verifySession.FULFILL:
      draft.sessionChecked = true;
      break;
    case loginUser.FAILURE:
    case logoutUser.FAILURE:
    case changePassword.FAILURE:
    case resetPasswordRequest.FAILURE:
    case resetPassword.FAILURE:
      draft.error = payload;
      break;
    case loginUser.FULFILL:
    case logoutUser.FULFILL:
    case changePassword.FULFILL:
    case resetPasswordRequest.FULFILL:
    case resetPassword.FULFILL:
      draft.loading = false;
      break;

    case showPassword.toString():
      draft.showPassword = payload;
      break;
    case showNewPassword.toString():
      draft.showNewPassword = payload;
      break;
    case showConfirmPassword.toString():
      draft.showConfirmPassword = payload;
      break;
  }
}, initialState);

export default reducer;
